<template>
  <div class="approvals">
      <h1 class="title">{{$t("settings.approvals")}}</h1>
      <div class="tabs">
        <ul>
            <router-link to="/approvals" tag="li" v-bind:class="{'is-active': !$route.params.nav }" exact>
                <a>
                    {{$t("settings.approvals")}}
                </a>
            </router-link>
            <router-link to="/approvals/absence" tag="li" v-bind:class="{'is-active': navAbsence }">
                <a>
                    {{$t("absence.absence")}}
                </a
            ></router-link>
        </ul>
      </div>
      <div class="columns">
         <div class="column">
            <div v-for="user in approverFor" v-if="!$route.params.nav && user['.value']" v-bind:key="user['.key']">
                <TimeApproverTable :user-id="user['.key']" :user-name="returnUserName(user['.key'])"></TimeApproverTable>
            </div>
            <div v-for="user in approverFor" v-if="navAbsence && user['.value']" v-bind:key="user['.key']">
                <AbsenceApproverTable :user-id="user['.key']" :user-name="returnUserName(user['.key'])"></AbsenceApproverTable>
            </div>
         </div>
         <div class="column" v-if="navAbsence">
             <AbsenceCalendar />
        </div>
       </div> 
  </div>
</template>

<script>
import firebase from '@/firebase'
import moment from 'moment'
import _ from 'lodash'

import TimeApproverTable from '@/components/TimeApproverTable.vue'
import AbsenceApproverTable from '@/components/AbsenceApproverTable.vue'
import AbsenceCalendar from '@/components/AbsenceCalendar.vue'

export default {
  name: 'approvals',
  components: {
      TimeApproverTable,
      AbsenceApproverTable,
      AbsenceCalendar
  },
  data: function () {
    return {
      approverFor: [],
      show: true
    }
  },
  firebase: function() { 
    const tenantid = JSON.parse(localStorage.getItem('profile')).tenantid;
    const userid = JSON.parse(localStorage.getItem('profile')).user_id;
    return {
        approverFor: {
            source: firebase.database().ref('/organisations/' + tenantid + '/users/' + userid + '/adminCanEdit/approverFor/'),
            asObject: false,
            cancelCallback: function () {},
            readyCallback: function () {}
        },
        orgUsers: {
            source: firebase.database().ref('/organisations/' + tenantid + '/users').orderByChild('adminCanEdit/active').equalTo(true),
            asObject: false,
        },
    }
  },
   computed: {
       navAbsence() {
           if(this.$route.params.nav === 'absence') {
               return true
           } else {
               return false
           }
       },
       weekBadge() {
           if(this.$route.params.time) {
               return this.$route.params.time
           } else {
                moment.locale(this.$i18n.locale)
                return moment().isoWeek();
           }
       }
   },
   methods: {
        returnUserName(uid) {
            return _.get(_.find(this.orgUsers, {'.key': uid}), 'userCanEdit.name')
       },
   }
}
</script>
<style scoped>
</style>
